import React from "react";
import Panel from "../../components/panels/panel";

import ContactBirthdayRowCard from "./birthday";

interface Props {
  config: server.dto.DashboardContactBirthdayPanelConfig
}

const ContactBirthdaysPanel = (props: Props) => {
  const [birthdays, setBirthdays] = React.useState<server.dto.ContactBirthday[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    window.CoreApi.Contact.Birthdays(undefined)
      .then((res) => {
        setBirthdays(res.data.data);
        setIsLoading(false);
      })
      .catch(() => { setHasError(true); });
  }, []);

  return <Panel
    title={props.config.headerLabel}
    isLoading={isLoading}
    panelClassName="s1_dashboard-panel"
    hasError={hasError}
    hasData={birthdays.length > 0}
  >
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {birthdays.map((birthday, index) => (<ContactBirthdayRowCard key={birthday.contactId} isLast={index === birthdays.length - 1} birthday={birthday} ></ContactBirthdayRowCard>))}
      </div>
    </div>
  </Panel>;
};

export default ContactBirthdaysPanel;
